import React from "react";
import { FC } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useCompletionsQueryByMission, useStreak } from "../queries/completion-queries";
import { useMission } from "../queries/mission-queries";
import { Button, Container, Navbar, Table } from "react-bootstrap";
import { Coins } from "./coins";
import { categoryImgs } from "../types/Category";
import { useCreateCompletionMutation } from "../mutators/completion-mutators";
import { generateGUID } from "../util/Guid";
import { useDeleteMissionMutation } from "../mutators/mission-mutator";

export const MissionDetails: FC = () => {
    const { id } = useParams<{ id: string }>();
    const { mission } = useMission(id);
    const { completions, count } = useCompletionsQueryByMission(id);
    const createCompletionMutation = useCreateCompletionMutation();
    const deleteMissionMutation = useDeleteMissionMutation();
    const nav = useNavigate();
    const { remainingDays, streakExpired, streakLength, streakLvl, bonusPerC, available } = useStreak(id)
    const maxItems = 20;

    if (!id || !mission || !completions) {
        if (sessionStorage.getItem('lvl-up') !== 'true')
            nav("/missions");
        return (<></>)
    }

    const handleComplete = async () => {
        const bonus = (available && bonusPerC ? Math.floor(mission.reward * bonusPerC / 100) : 0)
        await createCompletionMutation.mutateAsync({
            missionId: id,
            date: new Date(),
            coins: mission.reward + bonus,
            category: mission.category
        });
    }

    return (
        <>
            <Navbar sticky="top" key={'nav-bar'} expand={false} className="bg-body-secondary mb-3">
                <Container fluid>
                    <h2 className="mb-0">{mission.title}</h2>
                </Container>
            </Navbar>

            <div className="d-flex justify-content-between p-3">
                <div>
                    <span className="pe-2 fs-3">{mission.category}</span>
                    <img
                        src={categoryImgs[mission.category]}
                        width="40"
                        height="40"
                        className="d-inline-block align-top"
                        alt={mission.category}
                    />
                </div>
                <Button onClick={handleComplete}>Complete for <Coins coins={mission.reward} fontSize={6} size={12} /></Button>
            </div>
            {
                available ?
                    <div className="d-flex justify-content-between p-3">
                        <div>
                            <span className="pe-2">Streak</span>
                            <img
                                src={`/img/streak${streakLvl}.png`}
                                width="30"
                                height="30"
                                className="d-inline-block align-top"
                                alt={streakExpired ? 'streak expired' : 'streak'}
                            />
                            <span className="ps-2">+{bonusPerC}%</span>
                        </div>
                        <div>
                            {streakExpired ?
                                <span className="text-danger">Streak expired</span> :
                                <span>{streakLength} day streak</span>
                            }
                            {remainingDays !== undefined && !streakExpired && <span> ({remainingDays} days left)</span>}
                        </div>
                    </div> :
                    <></>
            }
            <p style={{ textAlign: 'justify' }} className="p-3 bg-body-secondary">{mission.description}</p>
            <Navbar key={'nav-bar-4'} expand={false} className="bg-body-secondary mb-3">
                <Container fluid>
                    <h4 className="mb-0">History ({count})</h4>
                </Container>
            </Navbar>
            <Table>
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Coins</th>
                    </tr>
                </thead>
                <tbody>
                    {[...completions].splice(0, maxItems).map(completion => (
                        <tr key={completion.id}>
                            <td>{completion.date.toLocaleDateString()}</td>
                            <td>{completion.coins}</td>
                        </tr>
                    ))}
                    {completions.length > maxItems && <tr><td colSpan={2}>...</td></tr>}
                    {completions.length === 0 && <tr><td colSpan={2}>Nothing here yet 😥</td></tr>}
                </tbody>
            </Table>
            <Button
                variant="danger"
                className="w-100 mt-3"
                onClick={() => deleteMissionMutation.mutateAsync(mission.id)}>
                Delete Mission
            </Button>
        </>
    )
}